<template>
  <div id="player-general-performance-table">
    <v-data-table
      :headers="tableHeaders"
      :loading="loading"
      :items="periods"
      hide-default-footer
      dense
      disable-pagination
    >
      <!--<editor-fold desc="ITEM SLOT">-->
      <template v-slot:item="{ item }">
        <tr>
          <td class="text-no-wrap">
            {{ item.title }}
          </td>
          <td
            v-for="tableHeader in tableHeaders.slice(1)"
            :key="tableHeader.id"
          >
            <table-bar-value
              :value="getValue(item, tableHeader.value)"
              :max="maxValues[tableHeader.value]"
              :color="getColorFromValue(getValue(item, tableHeader.value), maxValues[tableHeader.value], tableHeader.reverse)"
              class="text-no-wrap"
            >
              {{ getValue(item, tableHeader.value) }}
            </table-bar-value>
          </td>
        </tr>
      </template>
      <!--</editor-fold>-->
      <!--<editor-fold desc="LOADING SLOT">-->
      <template slot="loading">
        <div
          class="pa-5 d-flex justify-center align-center"
          :style="'min-height: ' + (periods.length * 49)+'px'"
        >
          <v-progress-circular
            indeterminate
            size="48"
            width="4"
            color="grey lighten-2"
          />
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { getColorForValue } from '@/utils/helpers'
import TableBarValue from '@/components/helpers/TableBarValue.vue'

export default {
  name: 'PerformancePeriodTable',
  components: { TableBarValue },
  props: {
    periods: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    tableHeaders: {
      type: Array,
      required: true
    },
    maxValues: {
      type: Object,
      required: true
    }
  },
  methods: {
    getValue(item, key) {
      return item.teams[0].team_stats ? item.teams[0].team_stats[key] : null
    },
    getColorFromValue(value, max, reverse = false) {
      return getColorForValue(value, max, reverse)
    }
  }
}
</script>
